import { render, staticRenderFns } from "./RoleSwitcher.vue?vue&type=template&id=a26a5cfe"
import script from "./RoleSwitcher.vue?vue&type=script&lang=ts"
export * from "./RoleSwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports